export default __webpack_public_path__ + "static/media/NextToBoom.eaab5516.jpg";